// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2z08Q","modalForm":"UpgradeEpcsModal_modalForm__3o-Na","modalFooter":"UpgradeEpcsModal_modalFooter__358Ip"};